var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Dialog',{ref:"dialog",attrs:{"title":"删除确认","is-init-show":false},on:{"dialogSure":_vm.deleteData}},[_c('div',{staticClass:"delete-detail"},[_vm._v("\n    "+_vm._s(_vm.deleteTips)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }